import { Component, Inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
    selector: 'app-custom-toast',
    templateUrl: './custom-toast.component.html',
    styleUrls: ['./custom-toast.component.scss'],
    imports: [MatIcon]
})
export class CustomToastComponent {
    constructor(
        @Inject(MAT_SNACK_BAR_DATA) public data: { message: string },
        public snackBarRef: MatSnackBarRef<CustomToastComponent>
    ) { }
}
